import { useEffect, useState } from 'react'
import { PreviewLabels } from './PreviewLabels'
import { DeleteBanner } from './DeleteBanner'
import { ILabel } from 'components/CreatePost/PreviewComponents/LabelsComponents/LabelsContentComponents/Label'
import { IPostVariant } from 'types/PostInterface'
import { deletePost } from '../iconConfig'

interface Props {
  selectedIcon: string
  resetSelectedIcon: () => void
  post: IPostVariant
  labels: ILabel[]
  refreshPostLabels: (newLabels: ILabel[]) => void
}

export const ContentSelectedIcons = ({ selectedIcon, resetSelectedIcon, labels, post, refreshPostLabels }: Props) => {
  /* ----------------- STATE  */
  const [isVisible, setIsVisible] = useState(false)

  /* ----------------- USEEFFECT  */

  // Handle animation visibility on icon selection change
  const handleAnimation = async () => {
    if (selectedIcon === 'labels' || selectedIcon === 'delete') {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  /* ----------------- USEEFFECT  */
  useEffect(() => {
    handleAnimation()

    return () => setIsVisible(false)
  }, [selectedIcon])

  /* ----------------- RENDER  */
  const handleSelectedIconToRender = () => {
    switch (selectedIcon) {
      case 'labels':
        return (
          <PreviewLabels
            postId={post._id!}
            className={isVisible ? 'selected_container' : ''}
            labels={labels}
            refreshPostLabels={refreshPostLabels}
          />
        )

      case 'delete':
        return (
          <DeleteBanner
            className={isVisible ? 'selected_container' : ''}
            resetSelectedIcon={resetSelectedIcon}
            deletePost={() => deletePost(post)}
          />
        )

      default:
        return <></>
    }
  }

  return handleSelectedIconToRender()
}
